export default __webpack_public_path__ + "static/media/rating-not-my-thing-filled.9596923a.svg";